import styled from "styled-components";

export const PassWrapper = styled.div`
  width: fit-content;
  font-size: 47px;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  margin: auto;
`;
